import { render } from "./TheFooter.vue?vue&type=template&id=799f9165&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=799f9165&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-799f9165"

export default script